// import React from "react";
// import { Col, Container, Row } from "react-bootstrap";

// const Footer = () => {
//     return (
//         <React.Fragment>
//             <footer className="footer">
//                 <Container fluid>
//                     <Row>
//                         <Col sm={6}>
//                             {new Date().getFullYear()} © Mayave Jewellers.
//                         </Col>
//                         <Col sm={6}>
//                             <div className="text-sm-end d-none d-sm-block">
//                                 Design & Develop by Sdaemon
//                             </div>
//                         </Col>
//                     </Row>
//                 </Container>
//             </footer>
//         </React.Fragment>
//     )
// }

// export default Footer;

import React from "react";
    import { Col, Container, Row } from "react-bootstrap";

    const Footer = () => {
    return (
        <footer className="footer bg-light py-3 mt-auto">
        <Container fluid>
            <Row className="align-items-center text-center text-sm-start">
            <Col xs={12} sm={6} className="mb-2 mb-sm-0">
                © {new Date().getFullYear()} Mayave Jewellers.
            </Col>
            <Col xs={12} sm={6} className="text-sm-end text-center">
                Design & Develop by <strong>Sdaemon</strong>
            </Col>
            </Row>
        </Container>
        </footer>
    );
    };

    export default Footer;